// extracted by mini-css-extract-plugin
export default {"root":"yz6mZw","link":"vffyZg","arrow":"Nhd2l9","hovered":"nPoUS1","links":"Nydekb","hidden":"qn2elU"};